import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import {SettingsRoutingModule} from './settings-routing.module';

const MODULES = [
    SharedModule,
    SettingsRoutingModule
];

import {ProfileSettingsComponent} from './components/user-settings/profile-settings.component';

const COMPONENTS = [
    ProfileSettingsComponent
];

@NgModule({
    imports: [
        ...MODULES
    ],
    declarations: [
        ...COMPONENTS
    ]
})
export class SettingsModule {
}
